export default function RecommendSection() {
  return (
    <section className="py-16 px-4 relative">
      <div className="absolute inset-0 bg-gradient-to-br from-teal-50 to-white"></div>
      <div className="max-w-6xl mx-auto relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
          こんな方におすすめ
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {/* Recommendation 1 */}
          <div className="bg-white rounded-xl border border-teal-200 hover:shadow-xl transition-all duration-300 hover:border-teal-300 hover:-translate-y-2 text-center p-8">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-group-line text-2xl text-teal-600"></i>
            </div>
            <p className="text-lg font-medium text-gray-700">経営者仲間を増やしたい</p>
          </div>

          {/* Recommendation 2 */}
          <div className="bg-white rounded-xl border border-teal-200 hover:shadow-xl transition-all duration-300 hover:border-teal-300 hover:-translate-y-2 text-center p-8">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-rocket-line text-2xl text-teal-600"></i>
            </div>
            <p className="text-lg font-medium text-gray-700">ビジネスを加速させたい</p>
          </div>

          {/* Recommendation 3 */}
          <div className="bg-white rounded-xl border border-teal-200 hover:shadow-xl transition-all duration-300 hover:border-teal-300 hover:-translate-y-2 text-center p-8">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-heart-line text-2xl text-teal-600"></i>
            </div>
            <p className="text-lg font-medium text-gray-700">次世代の起業家を応援したい</p>
          </div>
        </div>
      </div>
    </section>
  );
}